const { Fragment } = wp.element;
const { PanelBody, PanelRow, TextControl, ToggleControl, SelectControl } = wp.components;
const { __ } = wp.i18n;
import { produce } from "immer";

import BColor from "../../BColor";
import BControlPro from "../../../../components/BControlPro";

const Watermark = ({ attributes, handleFeatures, isPremium }) => {
  const { type, enabled, text, color } = attributes.features.watermark || {};

  const updateWatermark = (property, value) => {
    handleFeatures({ ...attributes.features.watermark, [property]: value }, "watermark");
  };

  return (
    <PanelBody title={__("Watermark", "h5vp")} initialOpen={false}>
      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Watermark", "h5vp")}
        id="watermark"
        checked={enabled}
        onChange={() => updateWatermark("enabled", !enabled)}
        help={__("autoplay will not work if enabled", "h5vp")}
      />

      {enabled && (
        <Fragment>
          <SelectControl
            className="m-0"
            style={{ marginBottom: 0 }}
            value={type}
            labelPosition="side"
            label={__("Type", "h5ap")}
            options={[
              { label: "Uesr Email", value: "email" },
              { label: "User Name", value: "name" },
              { label: "Custom Text", value: "text" },
            ]}
            onChange={(type) => {
              updateWatermark("type", type);
            }}
            __nextHasNoMarginBottom
            help={
              ["email", "name"].includes(type) && (
                <span>
                  {__("only logged in user can see his/her ", "bpm")}
                  {type}
                </span>
              )
            }
          />

          {/* </PanelRow> */}
          {type === "text" && <TextControl value={text} onChange={(text) => updateWatermark("text", text)} />}

          <PanelRow>
            <label htmlFor="" className="label display-block">
              {__("Text Color", "h5vp")}
            </label>
            <BColor defaultColor="#f00" value={color} onChange={(color) => updateWatermark("color", color)} />
          </PanelRow>
        </Fragment>
      )}
    </PanelBody>
  );
};

export default Watermark;
